import { render, staticRenderFns } from "./FaQManagement.vue?vue&type=template&id=3ebfcb18&"
import script from "./FaQManagement.vue?vue&type=script&lang=js&"
export * from "./FaQManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports